import { useEffect } from 'react'

declare global {
  interface Window {
    dataLayer: any[]
  }
}

export const GTM_ID = 'GTM-PC4KG5JK'

/**
 * Installs Google Tag Manager.
 *
 * This project has no editable index.html, so the container snippet is
 * injected at runtime instead: the head script exactly as GTM provides it,
 * plus the <noscript> iframe as the first element inside <body>.
 *
 * Mounted once at the app root (App.tsx).
 */
export function useGoogleTagManager() {
  useEffect(() => {
    if (document.getElementById('gtm-base')) return

    // Google Tag Manager (head) — verbatim container snippet.
    const script = document.createElement('script')
    script.id = 'gtm-base'
    script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`
    document.head.appendChild(script)

    // Google Tag Manager (noscript) — first child of <body>.
    const noscript = document.createElement('noscript')
    noscript.id = 'gtm-noscript'
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`
    document.body.insertBefore(noscript, document.body.firstChild)
  }, [])
}
